import axios from "axios";
import { confirmAlert } from "react-confirm-alert";

type GetServerLifeCycleNameProps = {
	productCode: string;
	lifeCycle: string;
	seq: number;
	name: string;
};

const GetServerLifeCycleName = async (): Promise<GetServerLifeCycleNameProps[] | undefined> => {
	try {
			const response = await axios.get<GetServerLifeCycleNameProps[]>("/ifactory/api/lifecycle");
			return response.data;
	} catch (error:any) {
		confirmAlert({
			title: error.response.data,
			buttons: [{ label: "Yes" }],
		});
	}
};

export default GetServerLifeCycleName;